var map = {
	"./制糖行业数字化转型场景图谱.jpg": "d3fb",
	"./制糖行业结构示意图.jpg": "2843",
	"./医疗装备行业数字化转型场景图谱.jpg": "62f6",
	"./医疗装备行业结构示意图.jpg": "918a",
	"./印刷电路板(PCB)行业数字化转型场景图谱.jpg": "71c2",
	"./印刷电路板(PCB)行业结构示意图.jpg": "c15f",
	"./家电行业数字化转型场景图谱.jpg": "4477",
	"./家电行业结构示意图.jpg": "50af",
	"./工程机械行业数字化转型场景图谱.jpg": "1857",
	"./工程机械行业结构示意图.jpg": "718d",
	"./建材行业数字化转型场景图谱.jpg": "3dc0",
	"./建材行业结构示意图.jpg": "61c1",
	"./新能源汽车行业数字化转型场景图谱.jpg": "31b69",
	"./新能源汽车行业结构示意图.jpg": "c4dc",
	"./智能移动终端数字化转型场景图谱.jpg": "fb03",
	"./智能移动终端结构示意图.jpg": "b190",
	"./机器人行业数字化转型场景图谱.jpg": "47eb",
	"./机器人行业结构示意图.jpg": "5c08",
	"./民爆行业数字化转型场景图谱.jpg": "9bfb",
	"./民爆行业结构示意图.jpg": "4a3d",
	"./白酒行业数字化转型场景图谱.jpg": "4f0f",
	"./白酒行业结构示意图.jpg": "f0ae",
	"./石化行业数字化转型场景图谱.jpg": "8fb8",
	"./石化行业结构示意图.jpg": "5fd7",
	"./美妆日化行业数字化转型场景图谱.jpg": "7eef",
	"./美妆日化行业结构示意图.jpg": "68e8",
	"./船舶行业数字化转型场景图谱.jpg": "1377",
	"./船舶行业结构示意图.jpg": "09967",
	"./钢铁行业数字化转型场景图谱.jpg": "0255",
	"./钢铁行业结构示意图.jpg": "a9f3",
	"./锂电行业数字化转型场景图谱.jpg": "16f1",
	"./锂电行业结构示意图.jpg": "df87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07b2";